import axios from 'axios';

const axiosNoInterceptor = axios.create();

export default axiosNoInterceptor;